export type PatientStatus =
  | 'Pending'
  | 'FollowUp'
  | 'OnHold'
  | 'Reviewed'
  | 'Sent'
  | 'Lost'
  | 'Resolved';

export type AlertResult = 'Success' | 'Trouble';

export interface PatientTrackingStatusCounts {
  pending: number;
  followUp: number;
  onHold: number;
  reviewed: number;
  sent: number;
}

export interface CeOpenIssueCount {
  id: string;
  coveredEntityName: string;
  openIssueCount: number;
}

export interface TrackerAttentionItem {
  id: string;
  patientName: string;
  coveredEntityName: string;
  status: PatientStatus;
  currentIssue: string;
  nextAlertDate: string | null;
  reasons: string[];
}

export interface PatientTrackingLastAlertRun {
  result: AlertResult;
  sentDate: string;
  ceAlerted: number;
  emailsSent: number;
  errors: number;
  summary: string | null;
}

export interface PatientTrackingDashboardSummary {
  openIssueCount: number;
  totalPatients: number;
  patientsWithOpenIssues: number;
  closedIssueCount: number;
  statusCounts: PatientTrackingStatusCounts;
  followUpCount: number;
  overdueAlertCount: number;
  pendingCount: number;
  activeCeCount: number;
  totalCeCount: number;
  topCesByOpenIssues: CeOpenIssueCount[];
  attentionItems: TrackerAttentionItem[];
  lastAlertRun: PatientTrackingLastAlertRun | null;
}

export type PatientTrackingDashboardCardId =
  | 'pharmacyOpenIssues'
  | 'pharmacyTrackerHealth'
  | 'pharmacyCeOverview';

export type PatientTrackingDashboardCardConfig = {
  id: PatientTrackingDashboardCardId;
  title: string;
};

export const PATIENT_TRACKING_DASHBOARD_CARDS: PatientTrackingDashboardCardConfig[] = [
  { id: 'pharmacyOpenIssues', title: 'Open Issues' },
  { id: 'pharmacyTrackerHealth', title: 'Tracker Health' },
  { id: 'pharmacyCeOverview', title: 'Covered Entities' }
];

export const DEFAULT_PATIENT_TRACKING_DASHBOARD_ORDER: PatientTrackingDashboardCardId[] =
  PATIENT_TRACKING_DASHBOARD_CARDS.map((card) => card.id);
